$(function() {
    $.fn.tooltipster('setDefaults', {
        position: 'bottom'
    });

    $('.js-in-cart__input').on('focus', function() { $(this).select(); } );

    $('.js-in-cart__button').on('click', function(){
        Manogi.useInCart($(this).closest('.js-in-cart'));

    });

    $('.js-in-cart__select').on('change', function(){
        var $in_carts = $(this).closest('.js-in-carts');
        var id = $(this).val();
        $in_carts.find('.js-in-cart').addClass('u-hidden');
        $in_carts.find('.js-in-cart[data-id='+id+']').removeClass('u-hidden');
    });
     $(document).on('keyup', '.js-in-cart *[name=quantity]', function(){
        Manogi.validateInCartQuantity($(this));
    });

    $('.js-cart-quantity').on('keyup', function(){
        Manogi.changeCartQuantity($(this));
    });

    $('.js-change-cart-quantity').on('click', function(){
        var id = $(this).data('id');
        Manogi.persistCartQuantity($('input[name=quantity][data-id='+id+']'));
    });

    $('*[data-action=remove_cart_article]').on('click', function(){
        Manogi.removeCartArticle($(this));
    });

    $('*[data-action=remove_coupon]').on('click', function(){
        Manogi.removeCartCoupon($(this));
    });

    $('.js-redeem-coupon').on('click', function(){
        Manogi.redeemCouponInCart();
    });

    $(document).on('click', '.js-change-quantity-to', function(){
        var id = $(this).data('input-id');
        var $input = $('.tooltipstered[data-input-id='+id+']');
        Manogi.changeQuantityToAvailable($input);
        $input.tooltipster('hide');
    });

    $(document).on('click', '.js-keep-quantity', function(){
        var id = $(this).data('input-id');
        var $input = $('.tooltipstered[data-input-id='+id+']');
        $input.tooltipster('hide');
    });

    $(document).on('click', '.js-buy-available', function(){
        var id = $(this).data('id');
        var $input = $('.tooltipstered[data-input-id='+id+']');
        $input.tooltipster('hide');
        $input.closest('.js-in-cart').hide();
        Manogi.useInCart($('.js-in-cart[data-id='+id+']'));
    });

    $(document).on('click', '.js-cancel-buy-tooltip', function(){
        var id = $(this).data('id');
        var $input = $('.tooltipstered[data-input-id='+id+']');
        $input.tooltipster('hide');
    });




});
